<template>
  <div class="account-action">
    <b-navbar class="account-action-navbar d-none d-md-flex">
      <b-navbar-brand href="#">
        <amg-icon icon="AmgIcon" size="40" class="pointer invert" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto d-flex align-items-center">
          <!-- <b-nav-item href="#" class="mr-2">
            <b-form-select
              size="sm"
              v-model="selectedLanguage"
              :options="languageOptions"
              class="language-select"
            ></b-form-select>
          </b-nav-item> -->

          <b-nav-item href="#" class="mr-2">
            <dark-toggler class="invert" :size="'20'" />
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container class="main-container" v-if="isLoading">
      <AccountActionSkeleton />
    </b-container>

    <template v-if="!isLoading">
      <b-container
        class="main-container"
        v-if="isValidLink && !successResponse"
      >
        <div class="pdf-template">
          <div class="header-logo">
            <img :src="logoDebtSolutionWithTitle" width="110" alt="Logo" />
          </div>

          <div class="header-text">
            <p class="title" style="color: #f49c1a !important">
              A.M.G. DEBT SOLUTION
            </p>
            <p class="subtitle">Action Acceptance Letter</p>
          </div>

          <main>
            <p class="disclaimer">
              The information contained in the following document is legally
              privileged and confidential, intended for use by the individuals
              or entities listed below only. Anyone unauthorized is notified
              that any use or dissemination is strictly prohibited.
            </p>

            <!-- Client Data -->
            <SectionTitle title="CLIENT DATA" />
            <InfoTable :rows="clientData" />

            <!-- Creditor Data -->
            <SectionTitle title="CREDITOR DATA" />
            <InfoTable :rows="creditorData" />

            <!-- AMG Fee -->
            <SectionTitle title="TO A.M.G. DEBT SOLUTION" />
            <InfoTable :rows="amgData" />

            <!-- Negotiator -->
            <SectionTitle title="NEGOTIATOR" />
            <InfoTable :rows="negotiatorData" />

            <p class="final-note">
              Be it known that I, as a client of A.M.G. Debt Solution LLC or
              authorized agent of client, hereby accept the above action,
              considering the account work completely under following terms and
              conditions.
            </p>
            <p class="final-note-2">
              Settlement fee to be withdrawn the joint money market account.
            </p>

            <!-- <div class="signatures">
              <label>Client's Sign:</label>
              <div class="signature-line"></div>

              <label>Co - Client's Sign:</label>
              <div class="signature-line small"></div>
            </div> -->
          </main>
        </div>

        <div class="btn-accept">
          <b-button variant="success" @click="accept()" :disabled="isProcessing"
            ><b-spinner small v-if="isProcessing"></b-spinner
          >
          <span v-else>ACCEPT</span>
          </b-button>
        </div>
      </b-container>

      <b-container v-if="!isValidLink && !successResponse">
        <div class="expired-link-container">
          <div class="expired-card text-center">
            <div class="icon-container">
              <img
                class="icon"
                :src="logoDebtSolutionWithTitle"
                alt="Invalid Link Icon"
              />
            </div>

            <h2 class="title">Invalid link</h2>

            <p class="description">
              The link you are looking for has expired or is no longer available
            </p>
          </div>
        </div>
      </b-container>

      <b-container v-else-if="successResponse">
        <b-container>
          <div class="success-link-container">
            <div class="success-card text-center">
              <div class="icon-container">
                <img
                  class="icon"
                  :src="logoDebtSolutionWithTitle"
                  alt="Valid Link Icon"
                />
              </div>

              <h2 class="title">Thank you for accepting</h2>

              <p class="description">
                The process is completed. You can now close this window.
              </p>
            </div>
          </div>
        </b-container>
      </b-container>
    </template>
  </div>
</template>

<script>
import SectionTitle from "./components/SectionTitle.vue";
import InfoTable from "./components/InfoTable.vue";
import logoDebtSolutionWithTitle from "@/assets/images/icons/dashboard-ceo/logo-ds.png";
import DebtSolutionPdfService from "@/views/pages/debt-solution-pdf/service/debt-solution-pdf.service.js";
import AccountActionSkeleton from "@/views/pages/debt-solution-pdf/AccountActionSkeleton.vue";
import translations from "@/views/pages/debt-solution-pdf/data/translations.js";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";

export default {
  name: "ActionAcceptanceLetter",
  components: { SectionTitle, InfoTable, AccountActionSkeleton, DarkToggler },
  data() {
    return {
      isProcessing: false,
      selectedLanguage: "es",
      languageOptions: [
        { value: "es", text: "Español" },
        { value: "en", text: "English" },
      ],
      logoDebtSolutionWithTitle,
      isValidLink: false,
      isLoading: false,
      successResponse: false,
      pdfData: {
        address: null,
        balance: null,
        city: null,
        code: null,
        creditor_account: null,
        creditor_name: null,
        finalized_at: null,
        has_co_applicant: null,
        mobile: null,
        name_client: null,
        name_created_by: null,
        offer_date: null,
        other_fees: null,
        saving: null,
        settlement_amount: null,
        settlement_cost: null,
        settlement_fee: null,
        settlement_total: null,
        state: null,
        zipcode: null,
        client_account_id: null,
        charge_amg: null,
      },
    };
  },
  computed: {
    tr() {
      return translations[this.selectedLanguage];
    },
    clientData() {
      return [
        [
          { label: "NAME(S)", value: this.pdfData.name_client },
          { label: "CLIENT NUMBER", value: this.pdfData.mobile },
        ],
        [
          { label: "ADDRESS", value: this.pdfData.address },
          { label: "CITY", value: this.pdfData.city },
        ],
        [
          { label: "STATE", value: this.pdfData.state },
          { label: "ZIP", value: this.pdfData.zipcode },
        ],
      ];
    },
    creditorData() {
      return [
        [
          { label: "CREDITOR NAME", value: this.pdfData.creditor_name },
          { label: "ACCOUNT NUMBER", value: this.pdfData.creditor_account },
        ],
        [
          { label: "CURRENT BALANCE", value: this.pdfData.balance },
          { label: "SETTLEMENT AMOUNT", value: this.pdfData.settlement_amount },
        ],
        [
          { label: "SAVING", value: this.pdfData.saving },
          { label: "DATE", value: this.pdfData.offer_date },
        ],
      ];
    },
    amgData() {
      return [
        [
          { label: "SETTLEMENT FEE", value: this.pdfData.settlement_fee },
          { label: "SETTLEMENT COST", value: this.pdfData.settlement_cost },
        ],
        [
          {
            label: "SETTLEMENT TOTAL COST",
            value: this.pdfData.settlement_total,
          },
        ],
      ];
    },
    negotiatorData() {
      return [
        [
          { label: "DATE", value: this.pdfData.finalized_at },
          { label: "MEDIATOR", value: this.pdfData.name_created_by },
        ],
        [{ label: "CODE", value: this.pdfData.code }],
      ];
    },
    uniqueCode() {
      return this.$route.params.unique_code;
    },
  },
  async created() {
    await this.checkIfIsValidLink();
  },
  mounted() {},
  methods: {
    async checkIfIsValidLink() {
      try {
        this.isLoading = true;
        const { data } = await DebtSolutionPdfService.isValidLink(
          this.uniqueCode
        );
        this.isValidLink = data.valid;

        if (!this.isValidLink) {
          this.isLoading = false;
        }
      } catch (error) {
        this.showErrorSwal(
          error,
          "Invalid or expired link. Please, contact support."
        );
      }
    },

    async getLinkData() {
      try {
        const { data } = await DebtSolutionPdfService.getLinkData(
          this.uniqueCode
        );
        this.pdfData = data[0];
      } catch (error) {
        this.showErrorSwal(
          error,
          "Invalid or expired link. Please, contact support."
        );
      } finally {
        this.isLoading = false;
      }
    },

    async accept() {
      try {
        this.isProcessing = true;
        const payload = {
          account_action_id: this.pdfData.account_action_id,
          unique_code: this.uniqueCode,
          link_id: this.pdfData.link_id,
          id_account: this.pdfData.client_account_id,
          charge_amg: this.pdfData.charge_amg,
          entity_name: this.pdfData.creditor_name,
          account: this.getAccount(),
          id_user: this.pdfData.completed_by,
          id_negotiator: this.pdfData.negotiator_id,
          name_client: this.pdfData.name_client,
          id_creditor: this.pdfData.credit_id,
          id_phase: this.pdfData.result_phase_id,
        };
        const { data } = await DebtSolutionPdfService.accept(payload);
        if (data.success) {
          this.successResponse = true;
        }
      } catch (error) {
      } finally {
        this.isProcessing = false;
      }
    },

    getAccount() {
      const account = this.pdfData?.creditor_account;
      if (!account) return "Undefined";

      const lastDigits = account.slice(-4); // devuelve menos si es más corta
      return `#. ${lastDigits}`;
    },
  },
  watch: {
    isValidLink(newValue) {
      if (newValue !== null && newValue === true) {
        this.getLinkData();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  padding: 0 0 10px;
}

.pdf-template {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  max-width: 816px;
  margin: 18px;
  padding: 30px 40px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
}

.btn-accept {
  display: flex;
  justify-content: center;
  margin: 20px 0 10px;
}
.btn-accept > * {
  width: 50%;
  max-width: 420px;
}

.header-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  position: relative;
}

.header-logo img {
  position: absolute;
  left: 0;
}

.header-text {
  text-align: center;
}

.header-text .title {
  color: #f49c1a;
  font-size: clamp(20px, 4vw, 30px);
  line-height: 1.1;
}

.header-text .subtitle {
  color: #231f20;
  font-size: clamp(12px, 2.8vw, 16px);
  font-weight: bold;
}

.disclaimer {
  font-size: clamp(10px, 2.6vw, 12px);
  text-align: center;
  color: #231f20;
  margin: 8px 0 12px;
}

.final-note,
.final-note-2 {
  font-size: clamp(10px, 2.6vw, 12px);
  text-align: center;
  color: #231f20;
  padding: 4px 16px;
}

.signatures {
  margin-top: 50px;
  font-size: clamp(10px, 2.6vw, 12px);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.signatures label {
  color: #231f20;
  font-weight: bold;
}

.signature-line,
.signature-line.small {
  border-bottom: 1px solid #000;
  width: 30%;
  height: 1em;
}

@media (max-width: 992px) {
  .signatures {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 12px;
    row-gap: 10px;
    align-items: center;
    margin-top: 20px;
  }
  .signatures label {
    text-align: left;
    padding: 0 8px 0 0;
  }
  .signature-line,
  .signature-line.small {
    width: 100%;
    min-width: 0;
  }
}

@media (min-width: 768px) {
  .pdf-template {
    padding: 40px 30px;
    margin: 40px auto;
  }
  .btn-accept > * {
    width: 25%;
    max-width: none;
  }
}

@media (max-width: 576px) {
  .header-logo {
    margin: 16px 0 8px;
  }
  .header-logo img {
    position: static;
  }
}

.expired-link-container,
.success-link-container {
  display: flex;
  justify-content: center;
  // align-items: center;
  min-height: 100vh;
  padding: 20px;
  /* background-color: #f8f9fa; */
  box-sizing: border-box;
}

.expired-card {
  max-width: calc(100% - 40px);
  padding: calc(1.5rem + 1px);
}

.success-card {
  max-width: calc(100% - 40px);
  padding: calc(1.5rem + 1px) 0rem;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.icon {
  width: 200px;
  height: auto;
  max-width: 100%;
}

.title {
  font-size: clamp(24px, 3.3vw, 32px);
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.description {
  font-size: clamp(18px, 2.5vw, 24px);
  color: #555;
  margin: 0;
}

/* Ajuste en pantallas pequeñas */
@media (max-width: 480px) {
  .expired-card {
    padding: 20px 15px;
  }
  /* .icon {
    width: 60px;
  } */
}

.account-action-navbar {
  .b-navbar-nav,
  .b-nav-item,
  .b-navbar-brand,
  .b-navbar-toggle {
    display: flex;
    align-items: center;
  }
}

.dark-layout {
  .account-action {
    &-navbar {
      background-color: #17171a !important;
    }

    .invert {
      filter: invert(100%);
    }

    .title {
      color: #ffffff;
    }

    .description {
      color: #6e6e6e;
    }
  }
}
</style>
